import React from 'react'
import clsx from 'clsx'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

import { formatDate } from 'commons/date'
import { handlePercentage } from 'commons/usagePercentage'

const useStyles = makeStyles((theme) => ({
  color: {
    color: '#00B2AD',
  },
  minusCorol: {
    color: '#F74872',
  },
}))

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 22,
    borderRadius: 8,
  },
  colorPrimary: {
    backgroundColor: '#F0F0F0',
  },
  bar: {
    borderRadius: 8,
    backgroundColor: '#00B2AD',
  },
}))(LinearProgress)

export function CurrentUsage({ planBill }) {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const balance = R.prop('balance', planBill) ?? 0
  const totalBurned = R.prop('totalBurned', balance) ?? 0
  const totalEarned = R.prop('totalEarned', balance) ?? 0
  const usagePercentage = R.prop('usagePercentage', balance) ?? 0
  const percentage = handlePercentage(usagePercentage, totalBurned, totalEarned)
  const remaining = R.prop('remaining', balance) ?? 0

  const dateFrom = formatDate(
    R.path(['activeSubscription', 'period', 'startPeriod'], planBill),
  )
  const dateUntil = formatDate(
    R.path(['activeSubscription', 'period', 'endPeriod'], planBill),
  )

  return (
    <div className="w-full bg-white rounded-8 border-1 p-10">
      <Typography variant="subtitle1" className={clsx('flex-1 font-bold')}>
        {formatMessage({ id: 'planAndBilling.currentUsage.label' })}
      </Typography>
      <Typography className="text-12">
        {formatMessage(
          { id: 'planAndBilling.currentUsage.period.label' },
          { startDate: dateFrom, endDate: dateUntil },
        )}
      </Typography>
      <div className="my-40">
        <div className="flex justify-between my-2">
          <Typography>
            {formatMessage({
              id: 'planAndBilling.currentUsage.burn.and.balance.label',
            })}
          </Typography>
          <Typography>{`${Number(totalBurned).toLocaleString('en-US')}/${Number(
            totalEarned,
          ).toLocaleString('en-US')}`}</Typography>
        </div>
        <div style={{ position: 'relative' }}>
          <BorderLinearProgress variant="determinate" value={percentage} />
          <Typography
            style={{
              top: 1,
              left: `${percentage >= 50 ? percentage - 10 : percentage}%`,
            }}
            className={clsx(
              'w-full absolute  font-bold',
              percentage >= 50 ? 'text-white' : 'mx-2 text-black',
            )}
          >
            {`${percentage}%`}
          </Typography>
        </div>
      </div>
      <div className="border-t-1 pt-10 flex justify-between">
        <Typography className="flex items-center">
          {formatMessage({
            id: 'planAndBilling.currentUsage.remainingBalance.label',
          })}
        </Typography>
        <Typography
          className={clsx(
            'text-36 font-bold ',
            remaining >= 0 ? classes.color : classes.minusCorol,
          )}
        >
          {Number(remaining).toLocaleString('en-US')}
        </Typography>
      </div>
    </div>
  )
}
